const Builder = require('./BuilderBase');
const HiddenFor = require('./HiddenFor');
const DropDownSearch = require('./DropDownSearch');
const MultiPickerDropDownSearch = require('./MultiPickerDropDownSearch');
const ValueSearch = require('./ValueSearch');
const ActionButton = require('./actionElement/ActionButton');
const ToggleSearch = require('./ToggleSearch');
const RangeSearch = require('./Range');
const IncludedValueSearch = require('./IncludedValueSearch');

module.exports = class SearchPane extends Builder {
    constructor(title, properties) {
        super('searchPane_SearchPane', title, properties);
    }

    searchPane(title, properties) {
        let searchPane = new SearchPane(title, properties);
        this.addChildBlock(searchPane);
        return searchPane;
    }

    hiddenFor(role) {
        let hiddenFor = new HiddenFor(role);
        this.addChildBlock(hiddenFor, 'securityModifier');
        return this;
    }

    DropDownSearch(title, properties) {
        let child = new DropDownSearch(title, properties);
        this.addChildBlock(child);
        return child;
    }

    MultiPickerDropDownSearch(title, properties) {
        let child = new MultiPickerDropDownSearch(title, properties);
        this.addChildBlock(child);
        return child;
    }

    ValueSearch(title, properties) {
        let child = new ValueSearch(title, properties);
        this.addChildBlock(child);
        return child;
    }

    ActionButton(title, properties) {
        let child = new ActionButton(title, properties);
        this.addChildBlock(child);
        return child;
    }

    ToggleSearch(title, properties) {
        let child = new ToggleSearch(title, properties);
        this.addChildBlock(child);
        return child;
    }

    IncludedValueSearch(title, properties) {
        let child = new IncludedValueSearch(title, properties);
        this.addChildBlock(child);
        return child;
    }

    RangeSearch(title, properties, type = 'search') {
        let child = new RangeSearch(title, properties, type);
        this.addChildBlock(child);
        return child;
    }
};
